// DASHBOARD actions
/* eslint-disable */
import axios from 'axios';
import types from '../../types';

export default {
  [types.GET_CHART]: async (context, payload) => {
    try {
      return await axios.get('dashboard/get-statistic/' + payload.type).then((res) => {
        context.commit('STORE_CHART', res.data.data);
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
}
